import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { CHUONGTRINHDAOTAO_API, NGANHDAOTAO_API } from '../../../../utils/apiUrl';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';

const ChuongTrinhDaoTaoModal = ({ isOpen, handleClose, data, refetch }) => {
    const isEdit = !!data;
    const addMutation = useMutation((payload) => Post(CHUONGTRINHDAOTAO_API.CREATE_ITEM, null, payload));
    const updateMutation = useMutation((payload) => Put(CHUONGTRINHDAOTAO_API.UPDATE_ITEM, data?.id, payload));

    // Fetch NganhDaoTao for dropdown selection
    const { data: sectorsData } = useQuery(
        ['nganhDaoTaoDropdown', isOpen],
        () => Get(NGANHDAOTAO_API.GET_PAGING + '?PageSize=1000'),
        { enabled: isOpen }
    );

    const sectors = sectorsData?.data?.$values || sectorsData?.data || sectorsData?.items?.$values || sectorsData?.items || sectorsData?.$values || sectorsData || [];

    const initialValues = {
        maChuongTrinh: data?.maChuongTrinh || '',
        tenChuongTrinh: data?.tenChuongTrinh || '',
        nganhDaoTaoId: data?.nganhDaoTaoId || '',
        ghiChu: data?.ghiChu || ''
    };

    const validationSchema = Yup.object().shape({
        maChuongTrinh: Yup.string().required('Mã chương trình đào tạo là bắt buộc'),
        tenChuongTrinh: Yup.string().required('Tên chương trình đào tạo là bắt buộc'),
        nganhDaoTaoId: Yup.string().required('Ngành đào tạo liên kết là bắt buộc')
    });

    const handleSubmit = (values) => {
        const mutation = isEdit ? updateMutation : addMutation;
        mutation.mutate(values, {
            onSuccess: (res) => {
                if (res.id || res.status === 200 || res === true) {
                    toast.success(isEdit ? "Cập nhật chương trình đào tạo thành công!" : "Thêm chương trình đào tạo thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra, vui lòng thử lại.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isEdit ? 'Chỉnh sửa chương trình đào tạo' : 'Thêm chương trình đào tạo mới'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ngành đào tạo liên kết <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="nganhDaoTaoId"
                                            value={values.nganhDaoTaoId}
                                            onChange={handleChange}
                                            isInvalid={touched.nganhDaoTaoId && !!errors.nganhDaoTaoId}
                                        >
                                            <option value="">-- Chọn ngành đào tạo --</option>
                                            {sectors.map((s) => (
                                                <option key={s.id || s.Id} value={s.id || s.Id}>
                                                    {s.tenNganh || s.TenNganh}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{errors.nganhDaoTaoId}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Mã chương trình <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="maChuongTrinh"
                                            value={values.maChuongTrinh}
                                            onChange={handleChange}
                                            isInvalid={touched.maChuongTrinh && !!errors.maChuongTrinh}
                                            disabled={isEdit}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.maChuongTrinh}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên chương trình đào tạo <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenChuongTrinh"
                                            value={values.tenChuongTrinh}
                                            onChange={handleChange}
                                            isInvalid={touched.tenChuongTrinh && !!errors.tenChuongTrinh}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenChuongTrinh}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="ghiChu"
                                            value={values.ghiChu}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={addMutation.isLoading || updateMutation.isLoading}>
                                {(addMutation.isLoading || updateMutation.isLoading) ? 'Đang lưu...' : 'Lưu lại'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default ChuongTrinhDaoTaoModal;
